import React, { createContext, useState, useContext, useEffect, ReactNode } from 'react';
import useShowError from "../../hooks/useShowError"
import { useAppDispatch } from "../../app/hooks"
import {useRefreshToken} from '../../hooks/Users'
import {openLogin} from '../../activeScreenSlice'

type AuthContextType = {
  authToken: string;
  setAuthToken: React.Dispatch<React.SetStateAction<string>>;
  sessionTime: string;
  setSessionTime: React.Dispatch<React.SetStateAction<string>>;
};

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [authToken, setAuthToken] = useState<string>("");
  const [sessionTime, setSessionTime] = useState<string>("");
  const refreshTokenMutation = useRefreshToken();
  const showError = useShowError();
  const dispatch = useAppDispatch();

  const fetchNewAccessToken = () => {
    refreshTokenMutation.mutate(undefined, {
      onSuccess(response) {
        setAuthToken(response.access_token);
        setSessionTime(response.session_inactive_timeout_minutes);
      },
      onError() {
        localStorage.removeItem("expiration");
        localStorage.removeItem("ssoEnabled");
        setSessionTime("");
        setAuthToken("");
        dispatch(openLogin());
        showError("Error fetching new access token, please log in.")
      }
    })
  }

  // On initial load, attempt to get a new access token
  useEffect(() => {
    if(localStorage.getItem("expiration") !== null) {
      fetchNewAccessToken();
    }
  }, []);


  return (
    <AuthContext.Provider value={{ authToken, setAuthToken, sessionTime, setSessionTime}}>
      {children}
    </AuthContext.Provider>
  );
};

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useMyContext must be used within a MyProvider');
  }
  return context;
}


